export default __webpack_public_path__ + "static/media/logo.17b00a8c.svg";